/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Level } from ".";

export abstract class Transport {
  abstract send(level: Level, message: string, meta: any): void;

  error(message: string, meta: any) {
    return this.send("error", message, meta);
  }
  warn(message: string, meta: any) {
    return this.send("warn", message, meta);
  }
  info(message: string, meta: any) {
    return this.send("info", message, meta);
  }
  debug(message: string, meta: any) {
    return this.send("debug", message, meta);
  }
}
